import React from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'

import { withAppContext } from '../../utils/AppContext'
import Card from './Card'
import InputRangeWrap from '../InputRangeWrap'
import InputToggle from '../InputToggle'
import styles from '../../scss/ui/card.scss'

const TraitsCard = ({ appContext }) => (
    <Card title="General Qualities">
        {/* <h3>Qualities You Prize</h3> */}
        <InputRangeWrap
            labelA="Leader"
            labelB="Follower"
            max={10}
            min={0}
            value={appContext.scoreCalculator.getData('scaleWeights').leader}
            onChange={
                value => appContext.scoreCalculator.onUpdateCategory('leader', value, 'scaleWeights')
            }
        />
        <InputRangeWrap
            labelA="Ambitious"
            labelB="Content"
            max={10}
            min={0}
            value={appContext.scoreCalculator.getData('scaleWeights').ambitious}
            onChange={
                value => appContext.scoreCalculator.onUpdateCategory('ambitious', value, 'scaleWeights')
            }
        />
        <InputRangeWrap
            labelA="Work to Live"
            labelB="Live to Work"
            max={10}
            min={0}
            value={appContext.scoreCalculator.getData('scaleWeights').hedonistic}
            onChange={
                value => appContext.scoreCalculator.onUpdateCategory('hedonistic', value, 'scaleWeights')
            }
        />
        <div className={cx(styles.filterCard, 'vertical-middle')}>
            <div className="horizontal-owl-medium right-content">
                <span className="rangeLabel">NO</span>
                <span className="rangeLabel">YES</span>
            </div>
            <h3>Include Non-Human Characters?</h3>
            <InputToggle
                value={appContext.scoreCalculator.getData('importantWeights').human ? 1 : 0}
                onChange={
                    value => appContext.scoreCalculator.onUpdateCategory('human', value, 'importantWeights')
                }
            />
        </div>
    </Card>
)

TraitsCard.propTypes = {
    appContext: PropTypes.object.isRequired,
}

export default withAppContext(TraitsCard)



// WEBPACK FOOTER //
// ./src/ui/CarouselCards/TraitsCard.js